export default {
      id: "eye_open-usage",
      viewBox: "0 0 22 16",
      url: __webpack_public_path__ + "sprite.svg#eye_open-usage",
      toString: function () {
        return this.url;
      }
    }